import TableTemplate from "../../TableTemplate/tableTemplate";
import { StepOptionOrderType } from "../../../Interfaces/stepInterfaces";
import { useAppDispatch } from "../../../App/hooks";
import { store } from "../../../App/store";
import {
  IManualAddOrderFormValues,
  IManualOrderTableReport,
  IManualTablesSearchParam,
} from "../../../Interfaces/manualInterfaces";
import { setManualOrderFormValues } from "../../../Features/Manual/manualSlice";
import { getManualOrderTable } from "../../../Requests/manualRequests";
import TableUI from "./TableUI";

interface IManualOrderTableProps {
  searchParam: IManualTablesSearchParam;
}

const ManualOrderTable = ({ searchParam }: IManualOrderTableProps) => {
  const dispatch = useAppDispatch();

  const onTableRowClick = (row: IManualOrderTableReport) => {
    const getOptionOrderType = (o?: string) => {
      if (!o) return null;
      if (o === "Open") return StepOptionOrderType.Open;
      return StepOptionOrderType.Offset;
    };

    dispatch(
      setManualOrderFormValues({
        ...store.getState().manual.addOrderFormValues,
        instrumentId: row?.instrument,
        instrumentType: row?.instrumentType,
        optionOrderType: getOptionOrderType(row.optionType),
      } as IManualAddOrderFormValues)
    );
  };

  return (
    <div className="overflow-auto order-table">
      <TableTemplate<IManualTablesSearchParam, IManualOrderTableReport>
        refreshTableTime={5000}
        withSort
        getDataTable={(searchParam, offset, pageSize, sortingType) =>
          getManualOrderTable(searchParam, offset, pageSize, sortingType || "")
        }
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <TableUI
            reports={reports}
            onAction={onAction}
            onTableRowClick={onTableRowClick}
            sortingType={sortingType}
            setSortingType={setSortingType}
          />
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default ManualOrderTable;
